import { gql } from "@apollo/client";export default gql`mutation AddGroupDocumentMap(
    $objects: [home_explore_group_document_map_insert_input!]!
) {
    addGroupTabMap: insert_home_explore_group_document_map(objects: $objects) {
        affected_rows
    }
}
`;
